import { buildURL } from '../../../helpers/urls';
import { patch } from '../../../helpers/fetch';

// eslint-disable-next-line import/prefer-default-export
export const updateEventImages = (event) => {
  const url = buildURL('events/images');
  return patch(url, event);
};
